import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getTopSuccPassedTickets } from '../../api/axios';
import Table from '../Table/Table';
import { useTranslation } from 'react-i18next';

const TopSuccPassedTickets = () => {
  const { t } = useTranslation('global');
  const [loading, setLoading] = useState(true);
  const [allPassedTickets, setAllPassedTickets] = useState([]);
  const [displayedTickets, setDisplayedTickets] = useState([]);
  const [ticketsLimit, setTicketsLimit] = useState(10);
  const location = useLocation();
  const { startDate, endDate } = location.state || {};

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getTopSuccPassedTickets(startDate, endDate);
        
        const ticketCounts = {};
        response.forEach(ticket => {
          if (!ticket.serial_num) return;
          ticketCounts[ticket.serial_num] = (ticketCounts[ticket.serial_num] || 0) + 1;
        });
        
        const uniqueTickets = [];
        const processedSerials = new Set();
        
        response.forEach(ticket => {
          if (!ticket.serial_num || processedSerials.has(ticket.serial_num)) return;
          
          uniqueTickets.push({
            ...ticket,
            pass_count: ticketCounts[ticket.serial_num],
            date: ticket.datetime
          });
          
          processedSerials.add(ticket.serial_num);
        });

        uniqueTickets.sort((a, b) => b.pass_count - a.pass_count);
        setAllPassedTickets(uniqueTickets);
        setDisplayedTickets(uniqueTickets.slice(0, ticketsLimit));
      } catch (error) {
        console.error(t("reports.errorFetchingData"), error);
        setAllPassedTickets([]);
        setDisplayedTickets([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [startDate, endDate, t]);

  useEffect(() => {
    // Update displayed tickets when limit changes
    setDisplayedTickets(allPassedTickets.slice(0, ticketsLimit));
  }, [ticketsLimit, allPassedTickets]);

  const handleLimitChange = (e) => {
    const value = parseInt(e.target.value);
    if (!isNaN(value) && value > 0) {
      setTicketsLimit(Math.min(value, allPassedTickets.length));
    }
  };

  const columns = [
    { heading: t("reports.passCount"), value: "pass_count" },
    { heading: t("reports.ticket"), value: "serial_num" },
    { heading: t("reports.dateAndTime"), value: "datetime" },
    { heading: t("reports.barrier"), value: "reader" },
    { heading: t("reports.result"), value: "message" },
    { heading: t("reports.name"), value: "name" },
    { heading: t("reports.lastName"), value: "surname" },
    { heading: t("reports.phoneNumber"), value: "phone" },
  ];

  return (
    <div>
      <h2>{t("reports.TopPassedTickets")}</h2>
      {loading ? (
        <p>{t("reports.loading")}</p>
      ) : allPassedTickets.length === 0 ? (
        <p>{t("reports.noDataAvailable")}</p>
      ) : (
        <>
          <div className="tickets-control">
            <label>
              {t("reports.showTickets")}:
              <input
                type="number"
                min="1"
                max={allPassedTickets.length}
                value={ticketsLimit}
                onChange={handleLimitChange}
                className="tickets-limit-input"
              />
              / {allPassedTickets.length}
            </label>
          </div>
          <Table 
            data={displayedTickets} 
            column={columns}
          />
        </>
      )}
    </div>
  );
};

export default TopSuccPassedTickets;